<template>
  <el-dialog :visible.sync="visible">
    <div class="wrapper">
      <!--  v-show="visible" -->
      <div class="agreementModal">
        <div class="modal-warp">
          <div class="modal-title" v-show="!isArgue()">
            <div class="title">用户协议与隐私政策</div>
            <div class="desc">
              感谢您使用智云问诊，我们尊重并保护您的个人隐私，若您使用本软件服务，将通过《用户协议》与《隐私政策》中双方的相关权利、义务条款来收集、储存、使用、共享和保护您个人信息的条款，为确保您的个人权益不受侵害，请您仔细阅读，充分理解所有条款内容后再点击同意
            </div>
          </div>
          <div class="modal-content">
            <!-- <iframe width="100%" height="100%" :src="serviceAgreementUrl" frameborder="0"></iframe> -->
            <div class="content" :class="isArgue() ? '' : 'content-border'">
              <div v-for="(fr, idx) in frameList">
                <iframe
                  :key="idx"
                  width="100%"
                  :style="{ height: fr.height[idx] }"
                  :src="fr.src"
                  frameborder="0"
                ></iframe>
              </div>
              <div class="mask"></div>
            </div>
          </div>
          <div class="modal-footer">
            <el-checkbox v-model="isArgument">已阅读并同意上述协议</el-checkbox>
            <el-button :type="isArgument ? 'primary' : ''" :class="isArgument ? '' : 'disabled'" @click="handlerSubmit">
              确认并签署协议
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import dayjs from 'dayjs';
import Fetch from '@/api';
import agreementDialog from '@/pages/quickRoutes/agreement/components/agreementDialog';
import { STORAGE_KEY, HTTP_LINK } from '@/lib/constant';

export default {
  data() {
    return {
      visible: false,
      isArgument: false,
      frameList: [
        // {code: '', height: []}
      ],
      serviceAgreementUrl: '',
      serviceAgreementId: '',
      bizList: undefined
    };
  },
  created() {
    Fetch.get_biz_check([Constant.reqBizType.service, Constant.reqBizType.liability].join(',')).then(bizList => {
      this.bizList = Object.freeze(bizList);
      if (this.isArgue()) {
        this.serviceDialog(bizList);
        this.liabilityDialog(bizList);
      } else {
        this.legalDialog();
      }
    });
  },
  computed: {
    userInfo() {
      return this.$store.state.global.userInfo;
    },
    storageLegalKey() {
      return `${STORAGE_KEY.LEGAL_AGREEMENT}_${this.userInfo.userId}`;
    }
  },
  methods: {
    isArgue() {
      return localStorage.getItem(this.storageLegalKey) === '1';
    },
    handlerSubmit() {
      if (!this.isArgument) {
        this.isArgue()
          ? this.$message.warning('不同意《平台药师审方服务使用承诺函》我们将无法为您提供服务')
          : this.$message.warning('不同意《用户协议》与《隐私政策》我们将无法为您提供服务');
        return;
      }
      if (this.isArgue()) {
        Fetch.update_agreement_sign(this.serviceAgreementId).then(res => {
          this.$message.success('协议签署成功');
          this.visible = false;
          this.$store.dispatch('permission/getInfo');
        });
      } else {
        localStorage.setItem(this.storageLegalKey, '1');
        this.visible = false;
        this.isArgument = false;

        this.serviceDialog(this.bizList);
        this.liabilityDialog(this.bizList);
      }
    },
    legalDialog() {
      // 用户服务协议和法律声明及隐私权政策
      const h = ['1200px', '6400px'];
      this.frameList = [
        {
          src: HTTP_LINK.USER_SERVICE_AGREEMENT,
          height: h
        },
        {
          src: HTTP_LINK.LEGAL_STATEMENT_AND_PRIVACY_POLICY,
          height: h
        }
      ];
      this.visible = true;
    },
    serviceDialog(bizList) {
      // 服务协议弹框
      if (bizList) {
        let biz = bizList.filter(bizCheck => bizCheck.code === Constant.bizType.service);
        if (biz.length > 0 && this.$checkPower('a')) {
          const { agreementId, agreementUrl } = biz[0].hint;
          this.serviceAgreementId = agreementId;
          this.serviceAgreementUrl = agreementUrl;
          this.frameList = [
            {
              src: agreementUrl,
              height: ['100%']
            }
          ];
          this.visible = true;
        }
      }
    },
    liabilityDialog(bizList) {
      // 免责协议弹框(白名单内会提示)
      const preKey = `IS_HINT${dayjs().subtract(1, 'days').format('YYYYMMDD')}`;

      const key = `IS_HINT${dayjs().format('YYYYMMDD')}`;

      if (localStorage.getItem(preKey)) {
        localStorage.removeItem(preKey);
      }

      const isHint = localStorage.getItem(key) || '';

      const userInfo = this.$store.state.global.userInfo;

      if (bizList) {
        let biz = bizList.filter(bizCheck => bizCheck.code === Constant.bizType.liabilityWhiteListInner);
        if (biz.length > 0 && !(isHint.indexOf(userInfo.userId) > -1)) {
          const { agreementId, busiMobile, busiName } = biz[0].hint;
          agreementDialog.show({
            id: agreementId,
            principal: this.$checkPower('a'),
            content: `
为保障药店与平台的合法权益，并给药店提供更好的处方审核服务，需要签署《平台药师审方服务使用承诺函》，否则将影响该功能正常使用。请联系公司负责人尽快签署。如有疑问请联系业务经理：${
              busiName || ''
            } ${busiMobile || ''}`
          });

          localStorage.setItem(key, isHint.split(',').concat(userInfo.userId).filter(Boolean).join(','));
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.agreementModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: rgba($color: #000, $alpha: 0.7);
  z-index: 999;
  padding: 50px 0;
  .modal-warp {
    max-width: 1100px;
    min-width: 800px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    margin: 0 auto;
    border-radius: 5px;
    h1 {
      text-align: center;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      font-weight: 600;
    }
    .modal-title {
      width: 100%;
      text-align: center;
      padding: 32px 48px 0;
      margin-bottom: 20px;
      .title {
        height: 16px;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: rgba(36, 36, 36, 1);
        line-height: 16px;
      }
      .desc {
        margin-top: 17px;
        text-align: left;
        height: 48px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(36, 36, 36, 1);
        line-height: 24px;
      }
    }

    .modal-content {
      // width: 100%;
      flex: 1;
      // padding: 32px 48px 0;
      margin: 0 48px;
      overflow-y: auto;
      .content {
        position: relative;
        // margin-top: 20px;
        // background: rgba(247, 247, 247, 1);

        padding: 10px;
        margin-bottom: 4px;
      }
      .content-border {
        border-radius: 8px;
        border: 1px solid #f2f2f2;
      }
      .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .modal-footer {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      border-top: 1px solid #f2f2f2;
      .disabled {
        color: #c0c4cc;
        background-image: none;
        background-color: #fff;
        border-color: #ebeef5;
      }
    }
  }
}
</style>
